import React, { useState } from "react";
import { apiFetch } from "../utils/wkCommon";
import { isZh } from "../utils/language";

export default function FileFormDialog({
  user,
  file,
  onClose,
  onSaved,
}) {
  const [titleZh, setTitleZh] = useState(file?.title_zh || "");
  const [titleId, setTitleId] = useState(file?.title_id || "");

  async function save() {
    await apiFetch(`/api/document-files/${file.documentId}`, {
      method: "PUT",
      body: {
        data: {
          title_zh: titleZh,
          title_id: titleId,
          recordEditor: user?.username || "system",
        },
      },
    });

    onSaved();
    onClose();
  }

  return (
    <>
    <div className="lfd-overlay">
      <div className="lfd-dialog">
        <h3>{isZh() ? "重新命名檔案" : "Rename File"}</h3>

        <input
           className="lfd-input"
          placeholder="Chinese Title"
          value={titleZh}
          onChange={(e) => setTitleZh(e.target.value)}
        />

        <input
          className="lfd-input"
          placeholder="Judul Indonesia"
          value={titleId}
          onChange={(e) => setTitleId(e.target.value)}
        />

        <div className="lfd-actions">
          <button onClick={onClose}>
            {isZh() ? "取消" : "Cancel"}
          </button>
          <button
            className="lfd-btn primary"
            disabled={!titleZh || !titleId}
            onClick={save}
          >
            {isZh() ? "儲存" : "Save"}
          </button>
        </div>
      </div>
    </div>
    <style>{`
      .lfd-overlay {
        position: fixed;
        inset: 0;
        background: rgba(0,0,0,0.35);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9999;
      }

      .lfd-dialog {
        background: #fff;
        border-radius: 0.8rem;
        padding: 1.2rem;
        min-width: 26rem;
        max-width: 90%;
        box-shadow: 0 10px 30px rgba(0,0,0,0.2);
      }

      .lfd-title {
        font-size: 1.1rem;
        font-weight: 600;
        margin-bottom: 1rem;
      }

      .lfd-input {
        width: 95%;
        padding: 0.5rem 0.6rem;
        border-radius: 0.4rem;
        border: 1px solid #ccc;
        margin-bottom: 0.6rem;
        font-size: 0.9rem;
      }

      .lfd-actions {
        display: flex;
        justify-content: flex-end;
        gap: 0.5rem;
        margin-top: 0.8rem;
      }

      .lfd-btn {
        padding: 0.4rem 0.9rem;
        border-radius: 0.4rem;
        border: none;
        cursor: pointer;
        font-size: 0.85rem;
      }

      .lfd-btn.primary {
        background: #2f5fa7;
        color: white;
      }

      .lfd-btn.secondary {
        background: #eee;
      }
    `}</style>
    </>
  );
}
